// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function FormField$FormField(props) {
  let __className = props.className;
  let __hideLabel = props.hideLabel;
  let __required = props.required;
  let error = props.error;
  let hint = props.hint;
  let htmlFor = props.htmlFor;
  let required = __required !== undefined ? __required : false;
  let hideLabel = __hideLabel !== undefined ? __hideLabel : false;
  let className = __className !== undefined ? __className : "";
  let hintId = htmlFor !== undefined ? htmlFor + "-hint" : undefined;
  let errorId = htmlFor !== undefined ? htmlFor + "-error" : undefined;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("label", {
        children: [
          props.label,
          required ? JsxRuntime.jsx("span", {
              children: "*",
              className: Emotion.Css.css({
                color: Emotion.Utils.Color.primary,
                marginLeft: "0.25rem"
              })
            }) : null
        ],
        className: Emotion.Css.cx([
          Emotion.Css.css({
            fontFamily: Theme.Theme.Typography.fontFamily.sans,
            fontSize: "0.8125rem",
            fontWeight: "500",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: Emotion.Utils.Color.textSecondary
          }),
          hideLabel ? "sr-only" : ""
        ]),
        htmlFor: htmlFor
      }),
      props.children,
      error !== undefined ? JsxRuntime.jsx("p", {
          children: error,
          className: Emotion.Css.css({
            margin: "0",
            fontSize: "0.8125rem",
            color: Emotion.Utils.Color.error
          }),
          id: errorId,
          role: "alert"
        }) : (
          hint !== undefined ? JsxRuntime.jsx("p", {
              children: hint,
              className: Emotion.Css.css({
                margin: "0",
                fontSize: "0.8125rem",
                color: Emotion.Utils.Color.textSecondary
              }),
              id: hintId
            }) : null
        )
    ],
    className: Emotion.Css.cx([
      Emotion.Css.css({
        display: "flex",
        flexDirection: "column",
        gap: "0.4rem"
      }),
      className
    ])
  });
}

let FormField = {
  make: FormField$FormField
};

export {
  FormField,
}
/* Theme Not a pure module */
